<template>
  <div class="repair-order-detail">
    <a-descriptions class="app-region blank-t-v blank-b-v blank-l-h blank-r-h" title="报修信息" v-viewer bordered>
      <a-descriptions-item label="工单号">{{info.repair_order_no}}</a-descriptions-item>
      <a-descriptions-item label="所属社区">{{info.communityName}}</a-descriptions-item>
      <a-descriptions-item label="报修项目">{{info.repair_item_info.repair_item_title}}</a-descriptions-item>
      <a-descriptions-item label="报修位置">{{info.position}}</a-descriptions-item>
      <a-descriptions-item label="问题描述">{{info.repair_order_content}}</a-descriptions-item>
      <a-descriptions-item label="报修人员">{{info.people}}</a-descriptions-item>
      <a-descriptions-item label="联系电话">{{info.repair_order_contact_phone}}</a-descriptions-item>
      <a-descriptions-item label="报修时间">{{info.created_at}}</a-descriptions-item>
      <a-descriptions-item label="上门时间">{{info.repair_order_booking_datetime}}</a-descriptions-item>
      <a-descriptions-item label="报修照片">
        <a-space>
          <dy-image :src="value" v-for="value in info.repair_order_attachment_ids" :key="value"></dy-image>
        </a-space>
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions class="app-region blank-t-v blank-b-v blank-l-h blank-r-h" title="处理信息" v-viewer bordered>
      <a-descriptions-item label="维修人员">
        <a-space>
          <span>{{info.attendantsName}}</span>
          <a-button @click="assignOrder" size="small" type="primary" v-if="info.repair_order_state === 1 || info.repair_order_state === 2">分配</a-button>
        </a-space>
      </a-descriptions-item>
      <a-descriptions-item label="上门时间">{{info.repair_order_start_datetime}}</a-descriptions-item>
      <a-descriptions-item label="工单状态">{{info.repairOrderStatusText}}</a-descriptions-item>
      <a-descriptions-item label="完成时间">{{info.repair_order_end_datetime || '暂无信息'}}</a-descriptions-item>
      <a-descriptions-item label="处理结果">{{resultStatus.get(info.repair_order_result_status)}}</a-descriptions-item>
      <a-descriptions-item label="备注信息">{{info.repair_order_result_desc}}</a-descriptions-item>
    </a-descriptions>
    <div class="app-region blank-b-v blank-l-h blank-r-h">
      <div class="page-title">服务费项</div>
      <a-table :loading="tableOne.loading" :columns="tableOne.columns" :data-source="tableOne.data" rowKey="repair_item_service_id" :pagination="false"></a-table>
    </div>
    <a-descriptions class="app-region blank-t-v blank-b-v blank-l-h blank-r-h" title="服务评价" v-viewer bordered>
      <a-descriptions-item label="处理速度">
        <a-space>
          <a-rate v-model="info.repair_order_comment_processing_speed" disabled></a-rate>{{info.repair_order_comment_processing_speed}}星
        </a-space>
      </a-descriptions-item>
      <a-descriptions-item label="服务态度">
        <a-space>
          <a-rate v-model="info.repair_order_comment_service_attitude" disabled></a-rate>{{info.repair_order_comment_service_attitude}}星
        </a-space>
      </a-descriptions-item>
      <a-descriptions-item label="维修专业度">
        <a-space>
          <a-rate v-model="info.repair_order_comment_professional_degrees" disabled></a-rate>{{info.repair_order_comment_professional_degrees}}星
        </a-space>
      </a-descriptions-item>
      <a-descriptions-item label="评价内容" :span="3">{{info.repair_order_comment_content}}</a-descriptions-item>
      <a-descriptions-item label="评价时间">{{info.repair_order_comment_datetime}}</a-descriptions-item>
    </a-descriptions>
    <a-modal :title="peopleModal.title" :confirm-loading="peopleModal.loading" v-model="peopleModal.show" @ok="confirmPeopleModal" destroy-on-close centered>
      <a-form-model ref="form" :model="peopleModal.form" layout="vertical" :rules="peopleModal.rules">
        <a-form-model-item label="维修人员" prop="people">
          <a-select mode="multiple" v-model="peopleModal.form.people" placeholder="请选择维修人员">
            <a-select-option :value="value.repair_attendant_id" v-for="value in peopleOptions" :key="value.repair_attendant_id">{{value.repair_attendant_name}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import RepairOrderService from '@/io/repair_order.js';
  import PeopleConfigService from '@/io/people_config.js';
  import {
    repairOrderStatusText
  } from '@/io/dict.js';

  export default {
    name: 'MemberInfo',
    data() {
      let self = this;
      return {
        resultStatus:new Map([
          [1, '已解决'],
          [2, '未解决'],
          [3, '其他'],
          [null, '暂无信息'],
        ]),
        id: this.$route.params.id,
        communityId: this.$route.query.community_id,
        communityOptions: [],
        peopleOptions: [],
        info: {
          repair_item_info: {}
        },
        tableOne: {
          loading: false,
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '服务项目',
              dataIndex: 'repair_item_service_name'
            },
            {
              title: '数量',
              dataIndex: 'use_num'
            },
            {
              title: '费用',
              dataIndex: 'repair_item_price'
            }
          ]
        },
        peopleModal: {
          id: null,
          title: '分配',
          show: false,
          loading: false,
          form: {
            people: []
          },
          rules: {
            people: [
              {
                required: true,
                message: '请选择维修人员'
              }
            ]
          },
        },
      }
    },
    mounted () {
      Promise.all([
        this.initCommunity(),
        this.initPeople()
      ]).then(() => {
        this.initInfo();
      });
    },
    methods: {
      assignOrder(data) {
        this.peopleModal.show = true;
      },
      confirmPeopleModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.peopleModal.loading = true;
          RepairOrderService.assign(this.communityId, this.id, this.peopleModal.form.people).then(res => {
            this.$afterFormSubmit('分配成功', () => {
              this.initInfo();
            });
          }).catch(err => {}).finally(() => {
            this.peopleModal.loading = false;
            this.peopleModal.show = false;
            this.peopleModal.form = {
              people: []
            };
            this.$store.dispatch('isNewRepair');
          });
        });
      },
      initPeople() {
        return PeopleConfigService.list(this.communityId).then(res => {
          this.peopleOptions = res.map(val => {
            return {
              ...val,
              repair_attendant_name: `${val.repair_attendant_name}(${val.repair_attendant_phone})`
            }
          });
        }).catch(err => {});
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      initInfo() {
        this.tableOne.loading = true;
        RepairOrderService.info(this.id).then(res => {
          this.info = {
            ...res,
            position: res.repair_order_type === 1 ? res.repair_order_location : res.housing_info.full_name,
            communityName: this.communityOptions.filter(val => val.id === res.community_id)[0].name,
            repairOrderStatusText: repairOrderStatusText(res.repair_order_state === 4 && res.repair_order_pay_status ? 7 : res.repair_order_state),
            people: res.admin_user_id ? res.admin_user_name : res.repair_order_contact_name,
            attendantsName: res.attendants.map(val => val.repair_attendant_name).join('、')
          };
          this.tableOne.data = res.item_services.map(val => {
            return val;
          });
        }).catch(err => {}).finally(() => {
          this.tableOne.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>